import { render, staticRenderFns } from "./DistancesTable.vue?vue&type=template&id=450e28aa&"
import script from "./DistancesTable.vue?vue&type=script&lang=js&"
export * from "./DistancesTable.vue?vue&type=script&lang=js&"
import style0 from "./DistancesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports